var map = {
	"./007-microphone-1.png": 610,
	"./010-home.png": 611,
	"./013-document-1.png": 612,
	"./014-document.png": 613,
	"./015-color-palette.png": 614,
	"./017-video-camera.png": 615,
	"./024-like.svg": 616,
	"./1.svg": 617,
	"./155-credit-card.svg": 618,
	"./2.svg": 619,
	"./3.svg": 620,
	"./4.svg": 621,
	"./New Customer.svg": 622,
	"./NotOpen.svg": 623,
	"./Opened.svg": 624,
	"./Profit.svg": 625,
	"./SalesRevenue.svg": 626,
	"./Sent.svg": 627,
	"./Slack.svg": 628,
	"./address.svg": 629,
	"./adobe.svg": 630,
	"./arrow-left.svg": 631,
	"./arrow-right.svg": 632,
	"./birlesik-logo.png": 633,
	"./book.svg": 634,
	"./camera.svg": 635,
	"./chat.svg": 636,
	"./clipboard.svg": 637,
	"./cloud.svg": 638,
	"./columns.svg": 639,
	"./documentation.svg": 640,
	"./file.svg": 641,
	"./flat.svg": 642,
	"./headphone.svg": 643,
	"./iconfinder_trello_2317760.svg": 644,
	"./idea.svg": 645,
	"./image.png": 646,
	"./image.svg": 647,
	"./label.png": 648,
	"./layers.svg": 649,
	"./left.svg": 650,
	"./logo2.svg": 651,
	"./logo3.svg": 652,
	"./logo4.svg": 653,
	"./logo5.svg": 654,
	"./logo6.svg": 655,
	"./logoIn.svg": 656,
	"./paint.svg": 657,
	"./protection.svg": 658,
	"./quote.png": 659,
	"./repeat.svg": 660,
	"./right.svg": 661,
	"./strategy.svg": 662,
	"./theme.svg": 663,
	"./user.svg": 664,
	"./water-fall.svg": 665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 609;